const TVIcon = ({ width = 20 }) => (
	<svg width={width} height={width} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M24.9167 3.25H1.08333V20.5833H8.66666V22.75H17.3333V20.5833H24.9058L24.9167 3.25ZM22.75 18.4167H3.24999V5.41667H22.75V18.4167Z" fill="currentColor" />
	</svg>
);

export default TVIcon;